import React from "react";
import DashboardGrupos from "../components/DashboardGrupos";

// Function própria (exports.groupMembers), separada da `api`
const API_URL = (
  process.env.REACT_APP_GROUP_MEMBERS_API_URL ||
  "https://us-central1-achados-67630.cloudfunctions.net/groupMembers"
).replace(/\/$/, "");

export default function GroupMembersPage() {
  return <DashboardGrupos apiBase={API_URL} />;
}
